/**
 * pageCache — lichte in-memory cache voor "stale-while-revalidate": bij terug-
 * navigeren toont een pagina meteen de vorige data (geen leeg laadscherm) en
 * ververst op de achtergrond. Leeft zolang de SPA open is (weg bij harde refresh).
 *
 * Gebruik:
 *   const cached = getCached(key);            // direct tonen indien aanwezig
 *   ... fetch verse data ...
 *   setCached(key, data);                     // voor de volgende keer
 */
const _store = new Map();
const DEFAULT_TTL_MS = 5 * 60 * 1000; // 5 min "vers"; daarna nog wél getoond, maar als stale

export function getCached(key) {
  const e = _store.get(key);
  if (!e) return null;
  return { data: e.data, stale: Date.now() - e.at > (e.ttl || DEFAULT_TTL_MS), at: e.at };
}

export function setCached(key, data, ttl = DEFAULT_TTL_MS) {
  _store.set(key, { data, at: Date.now(), ttl });
}

export function clearCached(key) {
  if (key) _store.delete(key); else _store.clear();
}
